import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useConnectClientVersion = () => {
  return useFeatureFlag(FeatureFlagDeclarations.connectClientVersion);
};
